<template>
    <div class="dzVehicleDetail">
        <div class="baseinfo box">
            <div class="info-header">
                <div class="info-header-left">
                    <licensePlate :licenseNo="vehicleInfo.licenseNo" :licenseColor="vehicleInfo.licenseColor"
                        :vehicleSeat="vehicleInfo.vehicleSeat"></licensePlate>
                </div>

                <el-button type="primary" @click="showDzCreate = true">
                    修改车辆信息
                </el-button>
            </div>
            <el-descriptions :column="1" size="medium" border>
                <el-descriptions-item label="车辆照片">
                    <el-image v-if="vehicleInfo.vehiclePhoto" :src="mixinQiniuImg(vehicleInfo.vehiclePhoto)"
                        style="width: 160px; height: 100px;" fit="cover"
                        :preview-src-list="[mixinQiniuImg(vehicleInfo.vehiclePhoto)]"></el-image>
                    <span v-else>-</span>
                </el-descriptions-item>
                <el-descriptions-item label="状态标签">
                    <div class="status-tag">
                        <el-tag style="margin-left: 10px;" type="danger"
                            v-if="$utils.checkValidity(vehicleInfo.compulsoryTrafficInsuranceEnd) < 0">交强险已过期</el-tag>
                        <el-tag style="margin-left: 10px;" type="warning"
                            v-else-if="$utils.checkValidity(vehicleInfo.compulsoryTrafficInsuranceEnd) < 30">交强险即将过期</el-tag>
                        <el-tag style="margin-left: 10px;" type="danger"
                            v-if="$utils.checkValidity(vehicleInfo.commercialInsuranceEnd) < 0">商业险已过期</el-tag>
                        <el-tag style="margin-left: 10px;" type="warning"
                            v-else-if="$utils.checkValidity(vehicleInfo.commercialInsuranceEnd) < 30">商业险即将过期</el-tag>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item label="机构名称">{{ organizationName || '-' }}</el-descriptions-item>
                <el-descriptions-item label="车辆型号">{{ vehicleInfo.vehicleModel || '-' }}</el-descriptions-item>
                <el-descriptions-item label="车身颜色">
                    <CustomTag type="dark" :color="vehicleInfo.vehicleColor | filterConst('VEHICLECOLOR', 'color')">{{
                        vehicleInfo.vehicleColor || '-' }}</CustomTag>
                </el-descriptions-item>
                <el-descriptions-item label="核载人数">{{ vehicleInfo.vehicleSeat || '-' }}人</el-descriptions-item>
                <el-descriptions-item label="车辆编号">{{ vehicleInfo.vehicleNo || '-' }}</el-descriptions-item>
                <el-descriptions-item label="车辆所属">{{ vehicleInfo.companyName || '-' }}</el-descriptions-item>
                <el-descriptions-item label="车辆责任人">{{ vehicleInfo.vehicleResponsible || '-' }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions :column="1" size="medium" border>
                <el-descriptions-item label="绑定司机">{{ vehicleInfo.driverName || '-' }}</el-descriptions-item>
                <el-descriptions-item label="司机手机">{{ vehicleInfo.driverPhone || '-' }}</el-descriptions-item>
            </el-descriptions>
        </div>

        <el-tabs v-model="activeName" class="driver-tabs box">
            <el-tab-pane label="证件信息" name="info">
                <cardinfo v-if="activeName === 'info'" :info="vehicleInfo" @refresh="getvehicleInfo" />
            </el-tab-pane>
            <el-tab-pane label="保单信息" name="policy">
                <policy v-if="activeName === 'policy'" :info="vehicleInfo" @refresh="getvehicleInfo" />
            </el-tab-pane>
                <el-tab-pane label="订单记录" name="orders">
                <vehicleOrders v-if="activeName === 'orders'" :vehicleId="vehicleInfo.id" />
            </el-tab-pane>
            <el-tab-pane label="收入统计" name="income">
                <vehicleIncome v-if="activeName === 'income'" :vehicleId="vehicleInfo.id" />
            </el-tab-pane>
            <el-tab-pane label="监管数据" name="regulatoryData" v-if="btnPreFn('travel_survey_vehicle', false)">
                <regulatoryData v-if="activeName === 'regulatoryData'" :info="vehicleInfo" @refresh="getvehicleInfo" />
            </el-tab-pane>
            <el-tab-pane label="客运监管" name="supervise" v-if="btnPreFn('survey_vehicle', false)">
                <supervise v-if="activeName === 'supervise'" :vehicleId="vehicleInfo.id" />
            </el-tab-pane>
        </el-tabs>

        <el-drawer :visible.sync="showDzCreate" destroy-on-close :wrapperClosable="false" :before-close="handClose"
            size="50%">
            <DzCreate @success="handleSuccess" @cancel="handClose" :id="id" title="修改车辆信息"></DzCreate>
        </el-drawer>
    </div>
</template>

<script>
import vehicleInfoDialog from "./vehicleInfoDialog.vue";
import cardinfo from './tabs/cardInfo/cardInfo.vue'
import policy from './tabs/policy/policy.vue'
import regulatoryData from './tabs/regulatoryData/regulatoryData.vue'
import supervise from './tabs/supervision/supervision.vue'
import vehicleOrders from './tabs/vehicleOrders/vehicleOrders.vue'
import vehicleIncome from './tabs/vehicleIncome/vehicleIncome.vue'
import DzCreate from '../list/DzCreate.vue'
export default {
    name: "dzVehicleDetail",
    components: {
        vehicleInfoDialog,
        cardinfo,
        policy,
        regulatoryData,
        supervise,
        vehicleOrders,
        vehicleIncome,
        DzCreate
    },
    data() {
        return {
            id: this.$route.query.id,
            organizationName: '',
            activeName: 'info',
            vehicleInfo: {},
            loading: false,
            showDzCreate: false
        };
    },
    computed: {},

    watch: {
        activeName: {
            handler() {
            },
        }
    },
    created() {
        this.getvehicleInfo();
    },

    methods: {
        handleSuccess() {
            this.showDzCreate = false;
            this.getvehicleInfo();
        },
        handClose() {
            this.showDzCreate = false;
        },
        async getvehicleInfo() {
            if (!this.id) {
                return false;
            }

            let url = "/api/v1/manage/vehicle/" + this.id;
            let { code, data } = await this.$axios.get(url);
            if (code === 1) {
                this.vehicleInfo = {
                    ...data,
                    organizationName: await this.getOrgName(data.organizationId)
                };
                console.log("vehicleInfo.vehicleColor:", this.vehicleInfo.vehicleColor);
                this.organizationName = await this.getOrgName(data.organizationId)
            }
        },
    },
};
</script>

<style lang="less" scoped>
.dzVehicleDetail {
    display: flex;
    gap: 20px;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: var(--bg-color);

    &>.box {
        height: calc(100vh - 160px);
        background: #fff;
        padding: 20px;
        border-radius: 8px;
        overflow-y: auto;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);

        &::-webkit-scrollbar {
            width: 5px;
        }
    }

    .baseinfo {
        width: 380px;
        flex-shrink: 0;

        .info-header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 16px;
            border-bottom: 1px solid #ebeef5;
            margin-bottom: 8px;

            &-left {
                display: flex;
                align-items: center;
                font-size: 16px;
                font-weight: 600;
                color: #303133;
            }
            
            .el-button {
                border-radius: 6px;
            }
        }

        .status-tag {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 6px;
            
            .el-tag {
                margin-left: 0 !important;
            }
        }

        :deep(.el-descriptions) {
            border-radius: 8px;
            position: relative;
            overflow: hidden;
            margin-top: 16px;
        }

        :deep(.el-descriptions)::after {
            content: '';
            pointer-events: none;
            position: absolute;
            inset: 0;
            border-radius: 8px;
            border: 1px solid #EBEEF5;
            z-index: 1;
        }

        :deep(.el-descriptions-row) {
            display: flex;
        }

        :deep(.el-descriptions-item__cell) {
            border-top: 0;
            border-left: 0;
        }

        :deep(.el-descriptions-item__label.is-bordered-label) {
            width: 110px;
            flex-shrink: 0;
            background-color: #f5f7fa;
            font-weight: 500;
            color: #606266;
        }

        :deep(.el-descriptions-item__content) {
            flex: 1;
            color: #303133;
        }
    }

    .driver-tabs {
        flex: 1;
        
        /deep/ .el-tabs__header {
            margin-bottom: 16px;
        }
        
        /deep/ .el-tabs__item {
            font-size: 14px;
            
            &.is-active {
                font-weight: 500;
                color: #2B77FF;
            }
        }
        
        /deep/ .el-tabs__active-bar {
            background-color: #2B77FF;
        }
    }

    /deep/ .el-tabs__content {
        height: calc(100vh - 214px);
        overflow-y: auto;
        padding-right: 20px;

        &::-webkit-scrollbar {
            width: 5px;
        }

        &>div {
            width: 100%;
            height: 100%;
        }
    }

    /deep/ .el-tabs__nav-wrap::after {
        height: 1px;
    }
}
</style>